module.exports = __webpack_public_path__ + "img/im_logo.51f5046f.png";